import { render, staticRenderFns } from "./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=template&id=2a351434&"
import script from "./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=script&lang=js&"
export * from "./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=script&lang=js&"
import style0 from "./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=style&index=0&lang=scss&module=true&"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=style&index=0&lang=scss&module=true&"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=style&index=0&lang=scss&module=true&")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js").rerender("2a351434")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../../packages/aem/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/webcomponents-ui - release-finish/src/main/content/webcomponents/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a351434')) {
      api.createRecord('2a351434', component.options)
    } else {
      api.reload('2a351434', component.options)
    }
    module.hot.accept("./NsHomeMarketPurchasingOnlyBanner.vue?vue&type=template&id=2a351434&", function () {
      api.rerender('2a351434', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@nuskin/app-components/components/NsHomeMarketPurchasingOnlyBanner.vue"
export default component.exports